import { Select } from ".";

const MultiSelect = ({ data }) => {
  return <Select data={{ ...data, multi: true }} />;
};

export default MultiSelect;
